/* Video Player 
    * A base class to extend when adding new video players
    * Do not call these methods directly, this class is meant to be extended
*/

export default class VideoPlayer {
    constructor(config) {
        this.config = config;
        this.videoPlayer = null;

        this.status = {
            STOPPED: 0,
            PAUSED: 1,
            PLAYING: 2
        };
    }

    assignEvents() {}

    play() {}

    pause() {}

    stop() {}

    getCurrentTime() {}

    setCurrentTime(time) {}

    getDuration() {}

    getVolume() {}

    setVolume() {}

    onTimeUpdate() {}

    throwAnalyticEvent(category, action, label, value) {
        if (value) {
            HSN.DataLayer.helpers.metricEvent(null, category, action, label, value);
        }
        else {
            HSN.DataLayer.helpers.metricEvent(null, category, action, label);
        }
    }

    getVideoPlayer() {
        return this.videoPlayer;
    }

}



// WEBPACK FOOTER //
// ./assets/js/HSN/Widget/VideoPlayers/VideoPlayer.js